import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { Spin, Table } from "antd";

import { API_URL } from "../../shared/utils/Util";
import { getFetchT } from "../../shared/utils/TypedUtil";
import { useNotification } from "../../shared/hooks";
import { Customer, CustomerOrder } from "../../types/model";

type OrderHistoryProp = {
  customer: Customer;
  restaurantId: string;
};

export const OrderHistory = (props: OrderHistoryProp) => {
  const { t } = useTranslation();
  const { notifyError } = useNotification();
  const [orders, setOrders] = React.useState<CustomerOrder[] | undefined>(undefined);

  React.useEffect(() => {
    const url = `${API_URL}/v1/r/${props.restaurantId}/customers/${props.customer.id}/orders`;
    getFetchT<CustomerOrder[]>(url, setOrders, (err: any) => {
      notifyError(t("unable_to_fetch_order_history"), err);
    });
  }, [props.customer, t, notifyError]);

  if (orders === undefined) {
    return <Spin size="large" />;
  }

  const columns: any = [
    {
      title: "Date",
      dataIndex: "create_time",
      key: "create_time",
      defaultSortOrder: "descend",
      sortDirections: ["ascend", "descend"],
      sorter: (a: CustomerOrder, b: CustomerOrder) => {
        return a["create_time"].localeCompare(b["create_time"]);
      },
      render: (t: string, a: CustomerOrder, index: number) => {
        return dayjs(t).format("YYYY/MM/DD");
      },
    },
    {
      title: "Order Number",
      dataIndex: "pos_order_name",
      key: "pos_order_name",
      defaultSortOrder: "ascend",
      sortDirections: ["ascend", "descend"],
      sorter: (a: CustomerOrder, b: CustomerOrder) => {
        return a["pos_order_name"].localeCompare(b["pos_order_name"]);
      },
    },
    {
      title: "Pretax Price",
      dataIndex: "pretax_price",
      key: "pretax_price",
      render: (t: string, a: CustomerOrder, index: number) => {
        if (a.pretax_price) {
          return a.pretax_price / 100;
        }
        return "N/A";
      },
    },
    {
      title: "Tip",
      dataIndex: "tip",
      key: "tip",
      render: (t: string, a: CustomerOrder, index: number) => {
        if (a.tip) {
          return a.tip / 100;
        }
        return "N/A";
      },
    },
  ];

  return <Table dataSource={orders} columns={columns} />;
};
